// this is dummy module overlayed by interface.ts
